import { ListItem, ListItemButton, Typography } from '@mui/material'
import { IGridPopperListItem } from 'src/types'

import useStyles from './styles'

interface IGridPopperListItemProps {
  item: IGridPopperListItem
  handleClose: () => void
}

const GridPopperListItem = ({ item, handleClose }: IGridPopperListItemProps) => {
  const classes = useStyles()

  const handleClick = () => {
    item.onClick()
    handleClose()
  }
  return (
    <ListItem disablePadding>
      <ListItemButton disabled={item.disabled} onClick={handleClick}>
        <Typography className={classes.cardName} component="h4">
          {item.title}
        </Typography>
      </ListItemButton>
    </ListItem>
  )
}

export { GridPopperListItem }
